const _import = file => {
    return ()=>import(/* webpackChunkName: "[request]" */ `@/views/${file}.vue`)
}
import console from './console'
import client from './client'
import student from './student'
import education from './education'
import finance from './finance'
import finecarved from './finecarved'
import system from './system'
import user from './user'

const routes = [
    {
        path: '/',
        component: _import('Home'),
        name: 'home',
        redirect: '/workbench',
        children: [
            console, 
            user, 
            client, 
            student, 
            finance, 
            education, 
            system, 
            finecarved
        ]
    }, {
        path: '/onlyMobile/:params',
        component: _import('mobile/index'),
        name: 'onlyMobile',
    }, {
        path: '/login',
        component: _import('Login'),
        name: 'login',
        hidden: true
    }, {
        path: '*',
        redirect: '/'
    }, {
        path: '/updatePassword',
        component: _import('UpdatePassword'),
        name: 'updatePassword',
        meta: {
            auth: true
        }
    }
];

export default routes;


// WEBPACK FOOTER //
// ./src/router/syncRouter.js